export const LEADS_SAVE_CURRENT_LEADS_DATA = "LEADS_SAVE_CURRENT_LEADS_DATA"
export const SHOW_WHATSAPP_CALLING_MODAL = "SHOW_WHATSAPP_CALLING_MODAL"
export const HIDE_WHATSAPP_CALLING_MODAL = "HIDE_WHATSAPP_CALLING_MODAL"
export const LEADS_DELETE_CURRENT_LEADS_DATA = "LEADS_DELETE_CURRENT_LEADS_DATA"
export const LEADS_SET_IS_ASSIGNED_TAB = "LEADS_SET_IS_ASSIGNED_TAB"
export const LEADS_SET_INCLUDE_CLOSED_OLDER_THAN_60 = "LEADS_SET_INCLUDE_CLOSED_OLDER_THAN_60"
export const SET_RESPONSE_LEAD_AUTO_BEGIN = "SET_RESPONSE_LEAD_AUTO_BEGIN"
export const SET_RESPONSE_LEAD_AUTO_SUCCESS = "SET_RESPONSE_LEAD_AUTO_SUCCESS"
export const SET_RESPONSE_LEAD_AUTO_FAILURE = "SET_RESPONSE_LEAD_AUTO_FAILURE"
export const SET_RESPONSE_LEAD_AUTO_NULL = "SET_RESPONSE_LEAD_AUTO_NULL"
export const SET_RESPONSE_GROUP_FILTERS = "SET_RESPONSE_GROUP_FILTERS"
export const CLEAR_RESPONSE_GROUP_FILTERS = "CLEAR_RESPONSE_GROUP_FILTERS"
export const LEADS_SET_INTERVAL = "LEADS_SET_INTERVAL"
export const FETCH_MESSAGES_BEGIN = 'FETCH_MESSAGES_BEGIN'
export const FETCH_MESSAGES_SUCCESS = 'FETCH_MESSAGES_SUCCESS'
export const FETCH_MESSAGES_FAILURE = 'FETCH_MESSAGES_FAILURE'
export const ADD_MESSAGE = 'ADD_MESSAGE'
export const SEND_MESSAGE_BEGIN = 'SEND_MESSAGE_BEGIN'
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS'
export const SEND_MESSAGE_FAILURE = 'SEND_MESSAGE_FAILURE'
export const CLEAR_CHAT = 'CLEAR_CHAT'
